<template>
  <div class="project-spot">
    <div class="project-title">{{ name }}</div>
    <div class="project-img">
      <img src="@/assets/leadCockpitImage/project.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  props: ["name"],
};
</script>
<style scoped>
.project-spot {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.project-title {
  color: #fff;
  background: #16c1b35e;
  border: 1px solid #16c1b3;
  padding: 5px 10px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.project-img {
  margin-top: 5px;
}
</style>